import autoComplete from "@tarekraafat/autocomplete.js";
import { accessibilityOptionsMFP } from "./modal";
import { copyToClipboard } from "./utils";

const standardSearchForm = document.querySelector(".standard-search-form form");

if (standardSearchForm) {
  document
    .querySelector(".standard-search-form input")
    .addEventListener("input", function (event) {
      const standardSearchError = document.querySelector(
        ".standard-search-error"
      );

      if (standardSearchError) {
        standardSearchError.remove();
      }
    });

  const autoCompleteJS = new autoComplete({
    selector: ".standard-search-form input",
    placeHolder: "GSE ID",
    threshold: 3,
    debounce: 300,
    data: {
      src: LOCALIZED.standards,
    },
    resultItem: {
      highlight: {
        render: true,
      },
    },
    resultsList: {
      class: "results_list",
    },
    events: {
      input: {
        selection: (event) => {
          const val = event.detail.selection.value.toLowerCase();
          window.location.href = LOCALIZED.home_url + "/standards/" + val;
        },
      },
    },
  });

  standardSearchForm.addEventListener("submit", (e) => {
    e.preventDefault();

    const standardSearchInput = document.querySelector(
      ".standard-search-form input"
    );
    const searchInput = standardSearchInput.value.toLowerCase();

    if ("" == searchInput) {
      return;
    }

    if (LOCALIZED.standards.includes(searchInput.toUpperCase())) {
      window.location.href = LOCALIZED.home_url + "/standards/" + searchInput;
    } else {
      const errorMessage = document.createElement("p");
      errorMessage.textContent =
        "Sorry, we couldn't find any standards with that identifier. Please try again.";
      errorMessage.classList.add("standard-search-error");
      standardSearchForm.append(errorMessage);
    }
  });
}

// Print.
const printButtons = document.querySelectorAll(".js-btn-print");

for (const printButton of printButtons) {
  printButton.addEventListener("click", function (e) {
    e.preventDefault();
    window.print();
  });
}

jQuery(document).ready(function ($) {
  // Sharer.
  $(".js-btn-share").magnificPopup({
    mainClass: "article-share-modal",
    ...accessibilityOptionsMFP,
  });
});

// Copy.
const copyButtons = document.querySelectorAll(".js-btn-copy");

for (const copyButton of copyButtons) {
  copyButton.addEventListener("click", function (e) {
    e.preventDefault();

    const standardTitle = document
      .querySelector(".page-header-heading")
      .textContent.trim();
    const standardObjective = document
      .querySelector(".page-header-objective")
      .textContent.trim();

    // Content section.
    const standardAdditionalContainer = document.querySelector(
      ".standard-details-additional"
    );
    const additionalContent = standardAdditionalContainer
      ? standardAdditionalContainer.textContent.trim()
      : "";

    let output = `${standardTitle}
    ${standardObjective}
    ${additionalContent}
    `;

    copyToClipboard(output);

    // Adding copied message.
    const newDiv = document.createElement("div");
    const newContent = document.createTextNode("Copied!");
    newDiv.appendChild(newContent);
    newDiv.className = "button-copy-text";
    newDiv.addEventListener("transitionend", () => newDiv.remove());
    this.after(newDiv);

    setTimeout(function () {
      newDiv.style.opacity = "0";
    }, 500);
  });
}
